import VoucherDetailsModal from './VoucherDetailsModal';

export default VoucherDetailsModal;
